import React, { useEffect } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import useDashboardContext from 'contexts/dashboard.context';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { apiService } from 'services/base.service';

import useBrandChefsContext from 'contexts/brand-chefs.context';
import EditRequestForm from './edit-request-form';
import RequestStatusTag from 'components/base/request-status-tag';
import { handleApiError } from 'utils/functions';

const EditRequest = () => {
  const { setIsBackLink, setBackLinkTitle, setBackLink } = useDashboardContext();
  const { activeRequest, setActiveRequest } = useBrandChefsContext();

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to vendors');
    setBackLink(MAIN_STORE_ROUTE_KEYS.VENDORS);
    return () => {
      setIsBackLink(false);
    };
  }, []);

  const getRequestItems = async () => {
    if (!activeRequest) return;
    try {
      const res = await apiService.get(`prep-kitchen-request/${activeRequest.id}`, {
        version: 'v2'
      });
      setActiveRequest(res.data.data);
    } catch (error) {
      handleApiError(error);
    }
  };
  useEffect(() => {
    getRequestItems();
  }, []);

  return (
    <div>
      <PageHeaderText
        title={`Request #${activeRequest.code}`}
        description='Need items from the kitchen? prepare your list'
        tag={<RequestStatusTag status={activeRequest.status} />}
      />
      <div className='max-w-[678px]'>
        <div>
          {' '}
          <EditRequestForm />{' '}
        </div>
      </div>
    </div>
  );
};

export default EditRequest;
